import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {
  isAddCourse: false,
};

const courseFunctionalSlice = createSlice({
  name: "courseFunctional",
  initialState,
  reducers: {
    setIsAddCourse: (state, action: PayloadAction<boolean>) => {
      state.isAddCourse = action.payload;
    },
  },
});

export const { setIsAddCourse } = courseFunctionalSlice.actions;
export default courseFunctionalSlice.reducer;
